module.exports = __webpack_public_path__ + "static/media/soda.4050e7a5.png";